import { Extension } from "../../core/extension";
import { SuggesterCallbacksRegistry, suggestPlugin, } from "../../core/suggest/suggest-plugin";
import { slashSuggester } from "./suggester";
import { SlashSuggesterPluginView } from "./components/SlashSuggesterPluginView/SlashSuggesterPluginView";
export class SlashCommandsExtension extends Extension {
    constructor() {
        super(...arguments);
        this.suggesterRegistry = new SuggesterCallbacksRegistry();
        this.commands = [];
    }
    addSuggesters(suggesters, slashCommands) {
        this.commands = slashCommands;
        return [...suggesters, slashSuggester(this.suggesterRegistry)];
    }
    addPlugins(schema, plugins, { portalContainer }) {
        return [
            ...plugins,
            suggestPlugin(portalContainer, this.suggesterRegistry, SlashSuggesterPluginView, {
                commands: this.commands,
            }),
        ];
    }
}
